// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const JenisPengikatanService = {};
 

JenisPengikatanService.postJenisPengikatan = function (data) {
  return lossClient({
    url: "/JenisPengikatan/add",
    method: "post",
    data: data,
  });
};

JenisPengikatanService.getJenisPengikatanList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/JenisPengikatan/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

JenisPengikatanService.getJenisPengikatanApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/JenisPengikatan/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

JenisPengikatanService.putJenisPengikatanApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag == "approve"
      ? { UserId: data.userId, Note: data.note }
      : { UserId: data.userId, Note: data.note };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "Return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "Reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "Approve")
      : (urlRequest = "");

 

  return lossClient({
    url: `/JenisPengikatan/${urlRequest}`,
    method: "put",
    headers: {
      "X-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

JenisPengikatanService.putJenisPengikatanRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/JenisPengikatan/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: bodyRequest,
  });
};

JenisPengikatanService.getJenisPengikatanDetail = function (data) {
  return lossClient({
    url: `/JenisPengikatan/${data.id}`,
    method: "get",
  });
};

JenisPengikatanService.updateJenisPengikatan = function (data) {
  // console.log("🚀 ~ data:", data);
  const { Id, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/JenisPengikatan/Edit",
    method: "put",
    headers: {
      "X-RequestId": data.Id,
    },
    data: requestBody,
  });
};

JenisPengikatanService.deleteJenisPengikatan = function (data) {
  // console.log(
  //   "🚀 ~ JenisPengikatanService.deleteJenisPengikatan ~ data:",
  //   data
  // );
  const { JenisPengikatanId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/JenisPengikatan/Delete",
    method: "delete",
    headers: {
      "X-requestid": data.JenisPengikatanId,
    },
    data: requestBody,
  });
};

export default JenisPengikatanService;
